export const getContentBetweenTwoStrings = (
  stringToSearch: string,
  leftSide: string,
  rightSide: string,
  startFromEnd?: boolean
) => {
  if (stringToSearch) {
    const leftSideLength = leftSide.length;
    const rightSideLength = rightSide.length - 1;
    const charStart = startFromEnd
      ? stringToSearch.lastIndexOf(leftSide) + leftSideLength
      : stringToSearch.indexOf(leftSide) + leftSideLength;
    const charEnd =
      stringToSearch.indexOf(rightSide, charStart) + rightSideLength;

    return stringToSearch.indexOf(leftSide) !== -1
      ? stringToSearch.slice(charStart, charEnd)
      : "";
  }

  return "";
};
